if (!customElements.get('header-tabs')) {
  customElements.define(
    'header-tabs',
    class HeaderTabs extends HTMLElement {
      constructor() {
        super();

        this.CLASSES = {
          buttonActiveClass: 'header-tabs__button--is-active',
          contentActiveClass: 'header-tabs__content--is-active',
        };

        /**
         * @type {NodeListOf<HTMLElement>}
         */
        this.buttons = this.querySelectorAll('.header-tabs__button');
        this.content = this.querySelectorAll('.header-tabs__content');

        this.buttons.forEach((button) => {
          button.addEventListener('click', this.handleClick.bind(this, button));
        });
      }

      /**
       *
       * @param {HTMLElement} button
       */
      handleClick(button) {
        const handle = button.dataset.handle;

        if (!handle) return;

        this.removeActiveTab();
        this.setActiveTab(handle);
      }

      /**
       *
       * @param {String} handle
       */
      setActiveTab(handle) {
        if (!handle) return;

        this.querySelector(`.header-tabs__button[data-handle="${handle}"`)?.classList.add(
          this.CLASSES.buttonActiveClass,
        );
        this.querySelector(`.header-tabs__content[data-handle="${handle}"`)?.classList.add(
          this.CLASSES.contentActiveClass,
        );
      }

      removeActiveTab() {
        this.querySelector('.header-tabs__button--is-active')?.classList.remove(this.CLASSES.buttonActiveClass);
        this.querySelector('.header-tabs__content--is-active')?.classList.remove(this.CLASSES.contentActiveClass);
      }
    },
  );
}
